import RegisterRequestModelBase from '../_generated/modelBases/register-request-model-base';

export default class RegisterRequestModel extends RegisterRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
